module.exports = __webpack_public_path__ + "img/iphone.f3356334.jpg";